import React from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem , Input, Button } from 'reactstrap';


const operators = [
  {name: "equals" , value: "="},
  {name: "before" , value: "<"},
  {name: "after" , value: ">"}
];

const filtersJobs = [
  { name: 'Required Date', value: 'preferredstartdatetime' },
  { name: 'Property', value: 'property' }
];

const filtersInvoices = [
  { name: 'Completed date' , value: 'invoiceapproveddate' },
  { name: 'Property', value: 'property' }
];

export default class Filter extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
        selectedFilter: this.props.extraFilters &&  this.props.extraFilters.raw ? this.props.extraFilters.raw.selectedFilter :  false,
        selectedOperator: this.props.extraFilters && this.props.extraFilters.raw ? this.props.extraFilters.raw.selectedOperator : false,
        date: this.props.extraFilters && this.props.extraFilters.raw ? this.props.extraFilters.raw.date : false
    };
  }

  updateJFState = (value) => this.setState({[value.name] : value.value});

  onChangeDate = (date) => {
    this.setState({ date: date.currentTarget.value });
  }

  onChange = () => {
    if (this.props.extraFilters.raw 
        && this.props.extraFilters.raw.date 
        && this.state.selectedOperator 
        && this.state.selectedFilter
    ) {
      let date = this.props.extraFilters.raw.date;
      let filterValue = this.state.selectedOperator !== '=' ? this.state.selectedOperator + date: date;
      let filter = {[this.state.selectedFilter]: filterValue };
      let keepFilter = {raw: this.state, ready: filter };
      this.props.keepFilters(keepFilter);
      this.props.fetchWithFilters(...this.props.woTypeAndOrder, 10, 1, filter);
    }
  }

  onSubmit = () => {
    if ((this.state.date || this.state.selectedFilter === 'property') 
        && this.state.selectedOperator 
        && this.state.selectedFilter
    ) {
      const filterValue = this.state.selectedOperator !== '=' 
          ? this.state.selectedOperator + (this.state.date || '')
          : this.state.date;

      let filter = {
        [this.state.selectedFilter === 'property' ? 'propertyid' : this.state.selectedFilter]: filterValue 
      };
      let keepFilter = {raw: this.state, ready: filter };
      this.props.keepFilters(keepFilter);
      this.props.fetchWithFilters(...this.props.woTypeAndOrder, 10, 1, filter);
    }
  }

  render() {

    const wrapperStyle = {
      width: "100%",
      display: "flex",
      flexFlow: 'row nowrap',
      justifyContent: 'flex-start',
      padding: "12px 0 12px 0",
      flexWrap: 'wrap'
    };

    const customStyle = {
      width: 220,
      marginRight: 24,
      cursor: 'pointer'
    };

    let filters = false;

    if(this.props.fType === 'jobs') {
      filters = filtersJobs;
    } else if (this.props.fType === 'invoices') {
      filters = filtersInvoices;
    }

    return (
      <div style={wrapperStyle}>

      <SelectList 
        onChange={this.onChange} 
        name='selectedFilter' 
        defaultValue={this.state.selectedFilter} 
        getObject={this.updateJFState} 
        values={filters}
        selectedFilter={this.state.selectedFilter}
      />

      

      {['invoiceapproveddate', 'preferredstartdatetime'].includes(this.state.selectedFilter) &&
      <SelectList 
        onChange={this.onChange} 
        defaultValue={this.state.selectedOperator} 
        name='selectedOperator' 
        getObject={this.updateJFState} 
        values={operators} 
        selectedFilter={this.state.selectedFilter}
      />
      }

      {this.state.selectedFilter === 'property' &&
      <SelectList 
        onChange={this.onChange} 
        defaultValue={this.state.selectedOperator} 
        name='selectedOperator' 
        getObject={this.updateJFState} 
        values={this.props.properties.map(property => {
          return {
            name: property.tabspropref + ' - ' + property.name,
            value: property.id
          };
        })}
        selectedFilter={this.state.selectedFilter}
      />
      }

      {this.state.selectedOperator && this.state.selectedFilter !== 'property' &&
      <Input
        defaultValue={this.state.date}
        onChange={this.onChangeDate}
        style={customStyle}
        type="date"
        name="date"
        id="exampleDate"
        placeholder="date placeholder"
      />
      }

      {this.state.selectedOperator && 
      <Button onClick={this.onSubmit} color="primary">
        Search
      </Button> 
      }

      </div>
    );
  }
}

class SelectList extends React.Component {

  constructor(props) {
    super(props);

    let selectedTitle = false;
    let selectedValue = false;
    let defaultValue = false;

    let values = this.props.values;

    defaultValue = values.filter((el)=>{
      return el.value === this.props.defaultValue;
    });

    if(defaultValue && defaultValue.length > 0) {
      defaultValue = defaultValue[0];
      selectedTitle = defaultValue.name;
      selectedValue = defaultValue.value;
    }

    this.state = {
      dropdownOpen: false,
      selectedTitle: selectedTitle,
      selectedValue: selectedValue
    };

    this.setValue = this.setValue.bind(this);
    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen
    }));
  }

  setValue(e) {
    let value = e.currentTarget.getAttribute("dropdownvalue");
    this.props.getObject({name: this.props.name, value: value });
    this.setState({selectedTitle: e.currentTarget.textContent, selectedValue: value }, () => {
      this.props.onChange(false);
    });
  }

  render() {
    const dropdownStyle = {
      width: 220,
      marginRight: 24,
      marginTop: 6,
    }

    const menuStyle = {
      maxHeight: '50vh',
      overflow: 'scroll'
    }

    const customStyleButton = {
      // width: 220,
      cursor: 'pointer'
    };

    let items = this.props.values.map((el,i)=>{
      return (<DropdownItem key={i + '32'} style={customStyleButton} onClick={ this.setValue } dropdownvalue={el.value} > {el.name} </DropdownItem>);
    });

    let titleTarget = 'filter';
    if (this.props.name === 'selectedOperator') {
      titleTarget = this.props.selectedFilter === 'property' ? 'property' : 'operator';
    }

    const defaultTitle = 'Select ' + titleTarget + '...';

    return (
      <div style={{ }}>
        <Dropdown style={dropdownStyle} isOpen={this.state.dropdownOpen} toggle={this.toggle}>
          <DropdownToggle style={dropdownStyle} caret>
            {this.state.selectedValue ? this.state.selectedTitle : defaultTitle }
          </DropdownToggle>
          <DropdownMenu style={menuStyle}>
            {items}
          </DropdownMenu>
        </Dropdown>
      </div>);
  }

}


// WEBPACK FOOTER //
// ./src/Filter.js